<template>
   <v-container fluid fill-height>
      <v-layout>
         <v-flex xs12 sm12 md12>
            <v-card class="rounded-lg">
               <v-toolbar color="#f8f9fb" elevation="0">
                  <v-toolbar-title> {{ `${this.$t("members.edit.title")}` }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                      <v-btn class="primary" @click="$router.go(-1)">
                        <v-icon left> mdi-chevron-double-left </v-icon>
                        {{ `${this.$t("members.edit.buttons.back")}` }}
                      </v-btn>
               </v-toolbar>
               <v-divider></v-divider>
               <v-card-text class="pa-10">
                  <v-form>
                     <v-row>
                        <v-col cols="12" x  s="12" sm="12" md="6">
                          <v-radio-group v-model="selected_type" row>
                            <v-radio
                              v-for="type in types"
                              :key="type.field"
                              :label="type.label"
                              :value="type.field"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                     </v-row>
                
                     <v-row v-if="selected_type=='flat'">
                        <v-col  cols="12" xs="12" sm="12" md="6">
                            <v-select
                              title="flat"
                              name="flat"
                              label="Block"
                              :items="flats"
                              item-text="name"
                              item-value="id"
                              v-validate="'required'"
                              v-model="member.flat_id"
                               :error="
                              errors.first('flat') != null ||
                              serverSideErrors.flat != null
                              "
                              :error-messages="
                              errors.first('flat') || serverSideErrors.flat
                              "
                             >      
                            </v-select>
                        </v-col>
                     </v-row>
                     <v-row>
                      
                        <v-col cols="12" xs="12" sm="12" md="6">
                          <v-radio-group  row v-model="member_type">
                            <v-radio
                              v-for="type in membertype"
                              :key="type.value"
                              :label="type.label"
                              :value="type.value"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                     </v-row>
                     <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6">
                           <v-text-field
                              v-model="member.house_number"
                              name="HouseNo"
                              label="House No / Shop No"
                              data-vv-as="House No" 
                              v-validate="'required'"
                              :error="
                              errors.first('HouseNo') != null ||
                              serverSideErrors.house_number != null
                              "
                              :error-messages="
                              errors.first('HouseNo') || serverSideErrors.house_number
                              "
                              ></v-text-field>
                        </v-col>
                     </v-row>
                     <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6">
                           <v-text-field
                              v-model="member.name"
                              name="name"
                              label="Person Name"
                              data-vv-as="House No" 
                              v-validate="'required'"
                              :error="
                              errors.first('name') != null ||
                              serverSideErrors.name != null
                              "
                              :error-messages="
                              errors.first('name') || serverSideErrors.name
                              "
                              ></v-text-field>
                        </v-col>
                     </v-row>
                       <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6">
                           <v-text-field
                              v-model="member.email"
                              name="email"
                              label="Email"
                              v-validate = "{ required : !!member.email }"
                              :error="
                              errors.first('email') != null ||
                              serverSideErrors.email != null
                              "
                              :error-messages="
                              errors.first('email') || serverSideErrors.email
                              "
                              ></v-text-field>
                        </v-col>
                     </v-row>
                     <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6" class="d-flex">
                          <vue-country-code
                  @onSelect="onSelect" 
                class="custom-country-code-select"
                :defaultCountry="flag"
          >
                
   </vue-country-code>
                           <v-text-field
                              v-model="member.mobile_no"
                              name="mobileNo"
                              label="Contact No"
                              data-vv-as="Contact No" 
                              v-validate="'required|max:10|min:10'"
                              :error="
                              errors.first('mobileNo') != null ||
                              serverSideErrors.mobileNo != null
                              "
                              :error-messages="
                              errors.first('mobileNo') || serverSideErrors.mobileNo
                              "
                              ></v-text-field>
                        </v-col>
                     </v-row>
                  </v-form>
               </v-card-text>
               <v-card-actions class="pb-5">
                  <v-btn color="secondary" dark class="px-8 ml-2" @click="saveHouseDetail" :loading="loading">Save</v-btn>
               </v-card-actions>
            </v-card>
         </v-flex>
      </v-layout>
   </v-container>
</template>
<script>
   import { mapMutations } from 'vuex';
   export default {
     data() {
       return {
         types : [
          {
            label : 'Block',
            field : 'flat'
          },
          {
            label : 'Single house',
            field : 'single_house'
          },
         ],
          membertype : [
          {
            label : 'Owner',
            value : 1
          },
          {
            label : 'Tenant',
            value : 2
          },
           ],
         user: {},
         loading: false,
         member: {
          
         },
  

         serverSideErrors: {},
         flats: [],
         selected_type : 'flat',
         member_type : 1,
         
       };
     },
     created() {
       this.user = JSON.parse(localStorage.getItem("user"));

       if(this.$route.params.id!='undefined'){
          this.getHouseDetail();
       }
    this.flag = JSON.parse(localStorage.getItem("flag"));

      this. getFlat();
      if (!localStorage.getItem("pageRefreshed")) {
      window.location.reload();
      localStorage.setItem("pageRefreshed", "true");
    } else {
      localStorage.removeItem("pageRefreshed");
    }
     },
     methods:{
      onSelect(event) {
      this.member.country_code = "+" + event.dialCode
      this.member.countryIso = event.iso2

    },
       ...mapMutations('alert',['setAlert']),
        saveHouseDetail() {
         let _self = this;
         this.$validator.validateAll().then((result) => {
           if (result) {
             _self.loading = true;
             let formData = new FormData();
             formData.append('selected_type',this.selected_type);
             formData.append('memberType',this.member_type);
             formData.append('name',this.member.name);
             formData.append('id',this.member.id);
             formData.append('email',this.member.email);
             formData.append('societyId',_self.user.id);
             formData.append('flatId',this.selected_type=='flat' ? this.member.flat_id  : '');
             formData.append('mobileNo',this.member.mobile_no);
             formData.append('houseShopNo',this.member.house_number);
             formData.append('country_code',this.member.country_code);
          formData.append('countryIso',this.member.countryIso);
             _self.$axios.put('/societyadmin/members/'+this.member.id,formData,
             {
               headers: {
                 'Content-Type':'multipart/form-data'
               }
             })
             .then( response => {
               let data = response.data;
               _self.loading = false;
               _self.serverSideErrors = {};
            
               if(data.status) {
                 this.setAlert({
                   showAlert : true,
                   message : data.message,
                   variant : 'green accent-4',
                   timeout : 2000
                 });
               _self.$router.push({ path: '/societyadmin/house/list' });
               } else {
                 if(!data.errors) {
                   this.setAlert({
                     showAlert : true,
                     message : data.message,
                     variant : 'red accent-3',
                     timeout : 2000
                   });
                 } else {
                   for(let i=0 ; i<data.errors.length ; i++) {
                     this.serverSideErrors[data.errors[i].field] = data.errors[i].message;
                   }
                 }
               }
             })
           }
         });
       },
     getFlat() {
      let _self = this;
      _self.$axios
         .get("societyadmin/flats")
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.flats = data.flats;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
     },
     getHouseDetail(){
        let _self = this;
      _self.$axios
        .get("societyadmin/members/" + _self.$route.params.id)
        .then((response) => {
        
          let data = response.data;
          console.log(data);
          if (data.status) {
            _self.member = data.member;
            localStorage.setItem(
              "flag",
              JSON.stringify(_self.member.countryIso)
            );
             this.member_type =  data.member.member_type;
            if(!_self.member?.flat_id){
              this.selected_type = 'single_house';
            }
            _self.member.email=data.member.email ? data.member.email : ''
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =  
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
     }
     },
    
   };
</script>
<style scoped>
   .font-30 {
   font-size: 30px !important;
   }
   /* make the icon clickable in badge slot */
   .edit-icon { 
   z-index: 1000;
   }
   .custom-country-code-select {
  width: 59px;
    height: 40px;
    margin-top: 3px;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    border-radius: 0;   
}
.vue-country-select:focus-within {
    box-shadow: none !important;
}
</style>